import { styled } from '../../config'

export const Text = styled('div', {
  variants: {
    size: {
      10: { fontSize: '10px', lineHeight: '16px', fontWeight: '$regular' },
      12: { fontSize: '12px', lineHeight: '18px', fontWeight: '$regular' },
      14: { fontSize: '14px', lineHeight: '20px', fontWeight: '$regular' },
      16: { fontSize: '16px', lineHeight: '24px', fontWeight: '$regular' },
      18: { fontSize: '18px', lineHeight: '24px', fontWeight: '$regular' },
      20: { fontSize: '20px', lineHeight: '24px', fontWeight: '$medium' },
      24: { fontSize: '24px', lineHeight: '32px', fontWeight: '$medium' },
      32: { fontSize: '32px', lineHeight: '40px', fontWeight: '$medium' },
      40: { fontSize: '40px', lineHeight: '50px', fontWeight: '$medium' }
    },
    weight: {
      light: { fontWeight: '$light !important' },
      regular: { fontWeight: '$regular !important' },
      medium: { fontWeight: '$medium !important' },
      semibold: { fontWeight: '$semibold !important' },
      bold: { fontWeight: '$bold !important' }
    },
    type: {
      primary: { color: '$white' },
      secondary: { color: '$gray0600' }
    },
    textAlign: {
      center: {
        textAlign: 'center'
      }
    },
    width: { full: { width: '100%' } },
    truncate: {
      true: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    },
    muted: {
      true: {
        opacity: '70%'
      }
    },
    link: {
      true: {
        '&:hover': {
          textDecoration: 'underline'
        }
      }
    }
  }
})
